import React from 'react';
import { Link } from 'react-router-dom';
import './Licenses.css';

const Licenses = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>خرید لایسنس اشتراکی | cPanel، DirectAdmin، Plesk و بیش از ۱۸ لایسنس | افراسل</h1>
        <p>خرید لایسنس اشتراکی با بهترین قیمت از افراسل. انواع لایسنس cPanel، DirectAdmin، Plesk، ImmunifyAV، LiteSpeed، CloudLinux، JetBackup، Softaculous، Virtualizor، KernelCare، SolusVM و WHMCS. لایسنس‌های اشتراکی با قیمت مناسب و پشتیبانی ۲۴ ساعته.</p>
        <meta name="description" content="خرید لایسنس اشتراکی با بهترین قیمت از افراسل. لایسنس cPanel، DirectAdmin، Plesk، ImmunifyAV، LiteSpeed، CloudLinux، JetBackup، Softaculous، Virtualizor، KernelCare، SolusVM و WHMCS." />
      </div>

      <section className="licenses-main-hero">
        <div className="licenses-main-hero-bg"></div>
        <div className="wrap">
          <div className="licenses-main-hero-content">
            <div className="licenses-main-badge">
              <span className="pulse-dot"></span>
              🏷️ لایسنس اشتراکی
            </div>
            <h1 className="licenses-main-hero-title">
              خرید لایسنس <em>اشتراکی</em> با بهترین قیمت
            </h1>
            <p className="licenses-main-hero-desc">
              تمام لایسنس‌های مورد نیاز برای هاستینگ و سرور را با بهترین قیمت از افراسل تهیه کنید.
              لایسنس‌های اشتراکی با قیمت مناسب و پشتیبانی ۲۴ ساعته.
              از cPanel و DirectAdmin تا Plesk و WHMCS، همه را در یک جا پیدا کنید.
              لایسنس‌های ما به صورت اشتراکی (ماهانه/سالانه) ارائه می‌شوند و نیازی به خرید اورجینال با هزینه بالا ندارید.
            </p>
            <div className="licenses-main-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۱۸+</span>
                <span className="stat-label">نوع لایسنس</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">اشتراکی</span>
                <span className="stat-label">ماهانه/سالانه</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="licenses-types">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">انواع لایسنس</span>
            <h2 className="sec-h">لایسنس <em>اشتراکی</em> برای نیاز شما</h2>
            <p className="sec-p">همه لایسنس‌های مورد نیاز برای هاستینگ و سرور را با بهترین قیمت از افراسل تهیه کنید.</p>
          </div>
          <div className="licenses-types-grid">
            {[
              { icon: '⚡', title: 'لایسنس cPanel / WHM', desc: 'لایسنس اشتراکی cPanel با قیمت مناسب و فعال‌سازی آنی. کنترل پنل محبوب هاستینگ با امکانات کامل.', features: ['فعال‌سازی آنی', 'پشتیبانی رسمی', 'قیمت رقابتی', 'نصب رایگان'], link: '/licenses/cpanel', color: '#06B6D4' },
              { icon: '🔧', title: 'لایسنس DirectAdmin', desc: 'لایسنس اشتراکی DirectAdmin با قیمت رقابتی و نصب رایگان. کنترل پنل سبک و سریع با منابع مصرفی کم.', features: ['قیمت رقابتی', 'نصب رایگان', 'پشتیبانی ۲۴/۷', 'فعال‌سازی آنی'], link: '/licenses/directadmin', color: '#EC4899' },
              { icon: '🛡️', title: 'لایسنس ImmunifyAV', desc: 'آنتی‌ویروس ایمونایفای برای محافظت از سرور در برابر بدافزارها و حملات سایبری. امنیت پیشرفته برای وب‌سایت‌ها.', features: ['امنیت پیشرفته', 'اسکن خودکار', 'حذف بدافزار', 'پشتیبانی ۲۴/۷'], link: '/licenses/immunify', color: '#22C55E' },
              { icon: '🚀', title: 'لایسنس LiteSpeed', desc: 'وب‌سرور لایت‌اسپید با عملکرد فوق‌العاده و کش پیشرفته. جایگزین قدرتمند Apache با سرعت بالا.', features: ['سرعت بالا', 'کش پیشرفته', 'بهینه‌سازی', 'پشتیبانی ۲۴/۷'], link: '/licenses/litespeed', color: '#F59E0B' },
              { icon: '☁️', title: 'لایسنس CloudLinux', desc: 'سیستم‌عامل ابری برای هاستینگ با ایزوله‌سازی کاربران و جلوگیری از تداخل منابع. مناسب برای هاستینگ‌های اشتراکی.', features: ['ایزوله‌سازی کاربران', 'مدیریت منابع', 'امنیت بالا', 'پشتیبانی ۲۴/۷'], link: '/licenses/cloudlinux', color: '#3B82F6' },
              { icon: '💾', title: 'لایسنس JetBackup', desc: 'راه‌حل حرفه‌ای بکاپ‌گیری با قابلیت بازیابی سریع. بکاپ خودکار از فایل‌ها و پایگاه داده.', features: ['بکاپ خودکار', 'بازیابی سریع', 'پشتیبانی از cPanel', 'پشتیبانی ۲۴/۷'], link: '/licenses/jetbackup', color: '#8B5CF6' },
              { icon: '📦', title: 'لایسنس Softaculous', desc: 'نصب خودکار بیش از ۴۰۰ اسکریپت با یک کلیک. وردپرس، جوملا، دروپال و هزاران اسکریپت دیگر با به‌روزرسانی خودکار.', features: ['۴۰۰+ اسکریپت', 'نصب یک‌کلیک', 'به‌روزرسانی خودکار', 'پشتیبانی ۲۴/۷'], link: '/licenses/softaculous', color: '#F97316' },
              { icon: '🖥️', title: 'لایسنس Virtualizor', desc: 'مدیریت مجازی‌سازی VPS با کنترل کامل و API پیشرفته. مناسب برای ارائه‌دهندگان هاست و VPS.', features: ['مدیریت VPS', 'API پیشرفته', 'کنترل کامل', 'پشتیبانی ۲۴/۷'], link: '/licenses/virtualizor', color: '#06B6D4' },
            ].map((type, i) => (
              <Link to={type.link} key={i} className="licenses-type-card">
                <span className="licenses-type-icon">{type.icon}</span>
                <h3 className="licenses-type-title">{type.title}</h3>
                <p className="licenses-type-desc">{type.desc}</p>
                <ul className="licenses-type-features">
                  {type.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="licenses-type-link" style={{ color: type.color }}>
                  خرید لایسنس ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="licenses-main-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              لایسنس <em>اشتراکی</em> مورد نیاز خود را خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید لایسنس از افراسل، از اشتراکی بودن، پشتیبانی رسمی و بهترین قیمت اطمینان داشته باشید.
              فعال‌سازی آنی و نصب رایگان در کنار شماست.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره خرید</button>
              <button className="btn-lg ghost" onClick={() => {
                const el = document.querySelector('.licenses-types-grid');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                مشاهده لایسنس‌ها
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Licenses;
